import { render, staticRenderFns } from "./MyUserProfile.vue?vue&type=template&id=05a571de&"
import script from "./MyUserProfile.vue?vue&type=script&lang=js&"
export * from "./MyUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MyUserProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports